import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type {
  AppNotification,
  MarkCaseCommentsReadResult,
  UnreadNotificationSummary,
} from '../../types/notification'

export const notificationService = {
  async list(params?: { page?: number; per_page?: number }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<AppNotification> | ApiSuccessResponse<AppNotification[]>
    >('/notifications', { params })
    return data
  },

  async markRead(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<AppNotification>>(
      `/notifications/${id}/read`,
    )
    return data
  },

  async markAllRead() {
    const { data } = await apiClient.post<ApiSuccessResponse<null>>(
      '/notifications/read-all',
    )
    return data
  },

  async unreadSummary() {
    const { data } = await apiClient.get<ApiSuccessResponse<UnreadNotificationSummary>>(
      '/notifications/unread-summary',
    )
    return data
  },

  async markCaseCommentsRead(caseId: string) {
    const { data } = await apiClient.post<
      ApiSuccessResponse<MarkCaseCommentsReadResult>
    >(`/notifications/cases/${caseId}/comments/read`)
    return data
  },
}
